"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _TransportDocumentPanel = require("../../components/print/TransportDocumentPanel");

var _TransportDocumentPanel2 = _interopRequireDefault(_TransportDocumentPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintableTransportDocument = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    transportDocuments: state.transportDocuments.transportDocuments
  };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PrintableTransportDocument, _Component);

  function PrintableTransportDocument() {
    (0, _classCallCheck3.default)(this, PrintableTransportDocument);
    return (0, _possibleConstructorReturn3.default)(this, (PrintableTransportDocument.__proto__ || (0, _getPrototypeOf2.default)(PrintableTransportDocument)).apply(this, arguments));
  }

  (0, _createClass3.default)(PrintableTransportDocument, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "print-container" },
        this.renderPages()
      );
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var transportDocuments = this.props.transportDocuments;


      if (transportDocuments.length < 1) {
        return _react2.default.createElement("div", null);
      }

      return _react2.default.createElement(_TransportDocumentPanel2.default, { transportDocument: transportDocuments[0] });
    }
  }]);
  return PrintableTransportDocument;
}(_react.Component), _class2.propTypes = {
  transportDocuments: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PrintableTransportDocument;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Print/PrintableTransportDocument.js
 ** module id = 1230
 ** module chunks = 0
 **/